<!-- 频道管理-->
<template>
  <div>
    <x-tabula
      ref="table"
      apiOrigin="PHP"
      :dataSource="dataSource"
      rowKey="channel_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptLen="4"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :deleteParam="deleteParam"
      :listApi="listApi"
      :rowSelection="false"
    >
    </x-tabula>
    <!-- 修改频道信息 -->
    <a-modal
      :title="moduleTitle"
      :visible="visible"
      :footer="null"
      @cancel="visible=false"
      :confirmLoading="btnLoading.loading"
      v-bind="this.$store.state.modalConfig"
    >
    <x-addEdit
      ref="form"
      apiOrigin="PHP"
      :formList="formList"
      :formKey="formKey"
      :addParam="addParam"
      :editParam="editParam"
      :detailParam="detailParam"
    >
    </x-addEdit>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'channelManage',
  data () {
    return {
      moduleTitle: '新增频道',
      visible: false,
      btnLoading: { loading: false },
      formList: [
        {
          label: '排序',
          inputType: 'input',
          options: [],
          placeholder: '请输入排序',
          props: ['sort', {
            rules: [
              { required: true, message: '请输入排序' }
              // { pattern: this.REG.mobile, message: this.MESSAGE.mobile }
            ]
          }]
        },
        {
          label: '频道名称',
          inputType: 'input',
          options: [],
          placeholder: '请输入频道名称',
          props: ['title', {
            rules: [
              { required: true, message: '请输入频道名称' },
              { max: 4, message: '频道名称不超过四个字' }
            ]
          }]
        }
      ],
      formKey: {
        sort: '',
        title: ''
      },
      addParam: {
        url: '/live/channels',
        reqHandle: this.addReqHandle,
        resHandle: this.addResHandle // this.addResHandle
      },
      editParam: {
        url: '/live/channels/',
        reqHandle: this.addReqHandle,
        resHandle: this.addResHandle // this.editResHandle
      },
      detailParam: {
        url: '/live/anchors',
        resHandle: this.detailResHandle
      },
      searchList: [
        { props: ['keywords'], placeholder: '频道名', options: [], inputType: 'input' }
      ],
      tableOptList: [
        { text: '新增', handle: () => this.openModel(), permi: ['community:channelManage:add'] }
      ],
      rowOptList: [
        { text: '标签管理', handle: (row) => this.goToLabel(row), permi: ['community:channelManage:label'] },
        { text: '修改', handle: (row) => this.openModel(row), permi: ['community:channelManage:edit'] },
        { text: '删除', handle: (row) => this.$refs.table.showDeleteConfirm(row), permi: ['community:channelManage:remove'] }
      ],
      columns: [
        { title: '排序', dataIndex: 'sort', align: 'left', width: '' },
        { title: '频道名', dataIndex: 'title', align: 'left', width: '' },
        { title: '创建时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        keywords: undefined
      },
      listApi: {
        url: '/live/channels', // live/applys
        resHandle: this.resHandle, // this.resHandle
        searchHandle: '' // searchHandle
      },
      deleteParam: {
        url: '/live/channels',
        param: { pk_key: 'channel_id', pk_val: '' },
        title: '频道名',
        key: 'title'
      }
    };
  },
  mounted () {},
  methods: {
    openModel (row) {
      this.visible = true;
      if (row) {
        this.detailParam.url = `/live/channels/${row.channel_id}`;
        // let url = `/live/anchors/${row.channel_id}`;
        this.$nextTick(() => {
          this.$refs.form.getDetail();
          this.$refs.form.routeQuery = row.channel_id;
        });
        this.moduleTitle = '编辑频道';
      } else {
        this.moduleTitle = '新增频道';
      }
    },
    goToLabel (row) {
      this.$router.push({
        name: 'channeLabel',
        query: {
          id: row.channel_id,
          name: row.title
        }
      });
    },
    addResHandle (res) {
      if (res.code === 1) {
        this.visible = false;
        this.$message.success(res.msg);
        this.$refs.table.getTableList();
      } else {
        this.$message.error(res.msg);
      }
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      // return selectData;
    }
  }
};
</script>
